<template>
  <div
    v-if="value && value.xAxis && value.xAxis.length && value.series && value.series.length"
    class="statistics__stacked-bar"
    ref="stackedBar">
  </div>
  <div
    v-else
    :key="emptyKey"
    class="dashboard-empty__container">
    <i class="iconfont icon-nodata"></i>
    <div>暂无数据</div>
  </div>
</template>

<script>
  // 堆叠柱状图
  import {clone} from "../../../../assets/js/Untis"
  import current from "./mixin"

  export default {
    mixins: [current],
    data() {
      return {
        emptyKey: Math.random(),
        optConf: {
          color: [],
          tooltip: {
            trigger: 'axis',
          },
          grid:{
            x: 30, // 距左
            y: 30, // 距上
            x2: 30, // 距右
            y2: 30, // 距下
            containLabel: true
          },
          legend: {

            /*
            type: 'scroll',
            orient: 'horizontal',
            bottom: 20,
            data: []
            * */
          },
          xAxis: null,
          /*[

            {
              id： 'dataId',
              name: 'fieldName'
              type: 'category',
              data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
              axisTick: {
                alignWithLabel: true
              }
            },

          ]
        */
          yAxis: {
            type: 'value'
          },
          series: null, /*[

            {
              type: 'bar',
              id: 'dataId',
              name: '直接访问',
              itemStyle: {
                color: ''
              }
              data: [10, 52, 200, 334, 390, 330, 220]
            }

          ]*/
        },
        chart: null,
        loaded: false,
      }
    },
    mounted() {
        if (this.$refs.line) {
          const chart = this.$ECharts.init(this.$refs.line)
          chart.title = ''
          this.chart = chart
          this.initChart()
        }

    },
    methods: {
      // 重新初始化图表 父级可调用
      initChart() {
        this.$nextTick(() => {
          if (!this.chart && this.$refs.line) {
            const chart = this.$ECharts.init(this.$refs.line)
            chart.title = ''
            this.chart = chart
          }
          if (this.value && this.chart) {
            const opt = clone(this.optConf)
            opt.color = this.showPropertiesHolder.theme.value
            const showFieldsColor = this.showPropertiesHolder.showFieldsColor
            const value = this.value
            if (value && value.xAxis && value.xAxis.length && value.series && value.series.length) {
              opt.xAxis = value.xAxis.map((item, idx) => {

                // x轴文字设置 --- 默认横向，不用设置
                let axisLabel = {}
                if (this.showPropertiesHolder.xAxisDirection === 'ver') {
                  axisLabel = {
                    formatter: function (value) {
                      return value.split("").join("\n")
                    }
                  }
                } else if (this.showPropertiesHolder.xAxisDirection === 'left') {
                  axisLabel = {
                    rotate: 30,
                  }
                } else if (this.showPropertiesHolder.xAxisDirection === 'right') {
                  axisLabel = {
                    rotate: -30,
                  }
                }

                return {
                  id: item.dataId,
                  type: 'category',
                  data: item.data.map(item => item.showValue),
                  axisLabel: axisLabel,
                  axisTick: {
                    alignWithLabel: true
                  }
                }
              })
              opt.series = value.series.map((item, idx) => {
                let color = ''
                if (showFieldsColor[item.dataId]) {
                  color = showFieldsColor[item.dataId]
                } else {
                  color = showFieldsColor[item.dataId] = opt.color[idx] || opt.color[0]
                }

                // 显示数据标签
                let normal = {
                  label: {
                    show: false
                  }
                }
                if (this.showPropertiesHolder.showDataTag) {
                  normal.label.show = true
                }
                return {
                  id: item.dataId,
                  type: 'line',
                  name: item.name,
                  data: item.data,
                  itemStyle: {
                    color,
                    normal
                  }
                }
              })

              // 显示图例配置
              if (this.showPropertiesHolder.showLegend) {
                opt.legend = this.showPropertiesHolder.legend.value
                // 动态设置间距
                if (this.showPropertiesHolder.legend.name === '底部') {
                  opt.grid.y2 = 60
                } else if(this.showPropertiesHolder.legend.name === '顶部') {
                  opt.grid.y = 70
                }
                if (opt.legend) {
                  opt.legend.data = value.series.map(item => item.name)
                }
              } else {
                opt.legend = null
              }

              // y轴最大值最小值
              if (this.showPropertiesHolder.yAxisMax.length) {
                opt.yAxis.max = Number(this.showPropertiesHolder.yAxisMax)
              }
              if (this.showPropertiesHolder.yAxisMin.length) {
                opt.yAxis.min = Number(this.showPropertiesHolder.yAxisMin)
              }

              // y轴标题
              if (this.showPropertiesHolder.yAxisTitle.length) {
                opt.yAxis.name = this.showPropertiesHolder.yAxisTitle
                opt.yAxis.nameLocation = 'center'
                opt.yAxis.nameTextStyle = {
                  padding: [0, 0, 40, 0]
                }
                // 动态设置间距
                opt.grid.x = 80
              }

              if (!opt.xAxis.length) {
                this.$toast.fail("没有维度数据")
                return
              }
              this.chart.setOption(opt, true, false, true)
              this.resize()
            } else {
              this.chart.clear()
              this.emptyKey = Math.random()
              this.chart = null
            }
            this.chart.on('click', params => {
              console.log('click',params)
              this.showDataDrillDownList(params)
            });
          }
        })
      },
      // 重置或初始化图表实例
      resize() {
        this.$nextTick(() => {
          if (this.chart) {
            this.chart.resize()
          }
        })
      }
    },
    watch: {
      // value 发生修改时 重新渲染图表
      value() {
        this.initChart()
      }
    }
  }
</script>

<style lang="less">
  .statistics__stacked-bar {
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>
